import { QRCodeSVG } from "qrcode.react";
import type { SavedHero } from "@greg-chick/shared";
import { heroRestoreUrl } from "../lib/heroApi";
import { encodeHeroParam } from "../lib/heroStorage";

// 내 히어로 카드(FR-HERO-10) — QR + 6자리 코드 + /h/:code 링크.
// 코드 있으면(온라인) 서버 복원 링크, 없으면(오프라인) ?h= URL 폴백(FR-HERO-13).
export function HeroCard({
  hero,
  syncing,
}: {
  hero: SavedHero;
  syncing: boolean;
}) {
  const hasCode = !!hero.code;
  const link = hasCode
    ? heroRestoreUrl(hero.code!)
    : `${window.location.origin}/?h=${encodeHeroParam(hero)}`;

  return (
    <div className="hero-card">
      <div className="hero-card__qr">
        <QRCodeSVG value={link} size={148} level="M" marginSize={2} />
      </div>

      {hasCode ? (
        <p className="hero-card__code" aria-label="내 히어로 코드">
          {hero.code}
        </p>
      ) : syncing ? (
        <p className="hero-card__status">코드 발급 중…</p>
      ) : (
        <p className="hero-card__status">
          오프라인: 아래 링크를 북마크하면 기기 변경 시 복원돼요.
        </p>
      )}

      <a className="hero-card__link" href={link} onClick={(e) => e.preventDefault()}>
        {link}
      </a>

      <p className="hero-card__hint">
        📸 스크린샷하거나 카톡·북마크로 보관하세요. 다른 기기에서 QR·코드·링크로
        내 히어로를 불러올 수 있어요.
      </p>
    </div>
  );
}
